/**
 * WordPress dependencies
 */
const { Component, Fragment } = wp.element;
const { __ } = wp.i18n;

export default class Tooltip extends Component {

	render() {
		if ( this.props.tooltip ) {
			return <button type="button" className="gf_tooltip tooltip" aria-label={ this.props.tooltip }>
				<i className="gform-icon gform-icon--question-mark" aria-hidden="true"></i></button>;
		} else {
			return null;
		}
	}
}
